/** Editor assistant copy stays typed through the main dictionary. */
export const ASSISTANT_EN = {
  "assistant.follow_up": "Follow up…",
  "assistant.queue_message": "Queue message",
  "assistant.queued_messages": "Queued messages",
  "assistant.queued": "Queued",
  "assistant.queue_paused": "Paused",
  "assistant.use_now": "Use now",
  "assistant.use_now_description": "Stop the current reply and use this message",
  "assistant.send_now": "Send now",
  "assistant.edit_queued": "Edit",
  "assistant.edit_queued_message": "Edit queued message",
  "assistant.remove_queued": "Remove",
  "assistant.save_queued": "Save",
  "assistant.stop": "Stop response",
  "assistant.stopping": "Stopping…",
  "assistant.stopped": "Stopped",
  "assistant.cancel_failed": "Couldn’t stop yet. Try again.",
  "assistant.queue_full": "Queue full. Remove a message to add another.",
  "assistant.not_applied": "Changes weren’t made.",
  "assistant.send_again": "Send a new request to try again.",
  "assistant.undone": "Change undone",
  "assistant.open": "Assistant",
  "assistant.options": "Assistant menu",
  "assistant.usage": "Credits and usage",
  "assistant.usage_loading": "Checking balance…",
  "assistant.usage_unavailable": "Balance unavailable. Try again.",
  "assistant.usage_explanation": "Credits are based on usage. Questions usually cost less. See costs in each reply’s menu.",
  "assistant.usage_limit": "Up to {cost} credits per request. Technical failures are free.",
  "assistant.refresh_usage": "Refresh balance",
  "assistant.message_options": "Message options",
  "assistant.low_credits": "{remaining} credits left",
  "assistant.no_credits": "You’re out of credits.",
  "assistant.more_credits": "Not enough credits for this request.",
  "assistant.send_notice": "Sends your message and drawing. Changes can be undone.",
  "assistant.about": "About the assistant",
  "assistant.fix": "Fix",
  "assistant.ask": "Ask",
  "assistant.checks": "System checks",
  "assistant.checks_empty": "No issues to review",
  "assistant.show_on_canvas": "Show on canvas",
  "assistant.close": "Close assistant",
  "assistant.back": "Back to drawing",
  "assistant.fullscreen": "Full screen",
  "assistant.exit_fullscreen": "Exit full screen",
  "assistant.capped": "The assistant is temporarily unavailable. Your draft is saved.",
  "assistant.rate_limited": "Too many requests. Your draft is saved. Try again shortly.",
  "assistant.beta": "Beta",
  "assistant.title": "How can I help?",
  "assistant.subtitle": "Ask a question, or tell me what to add, remove or rewire.",
  "assistant.context": "Your current drawing",
  "assistant.placeholder": "Ask Crimp…",

  "assistant.recover": "Recover reply",
  "assistant.drawn_wire": "Wire in drawing: {wire}",
  "assistant.drawn_fuse": "Inline fuse: {fuse} A",

  "assistant.send": "Send",
  "assistant.choose_for_me": "Choose for me",
  "assistant.choose_for_me_prompt": "Choose for me.",

  "assistant.privacy": "Sent messages and results are kept for 90 days to improve the assistant. Unsent drafts stay on this device.",
  "assistant.scope": "Energy uses the simulation. Cable and fuse sizing uses the design.",
  "assistant.progress.starting": "Starting…",
  "assistant.progress.reviewing_drawing": "Reviewing your drawing…",
  "assistant.progress.preparing_answer": "Preparing a reply…",
  "assistant.progress.checking_answer": "Checking the reply…",
  "assistant.progress.checking_changes": "Checking the changes…",
  "assistant.progress.retrying": "Revising the reply…",
  "assistant.progress.finishing": "Finishing up…",
  "assistant.progress.recovering": "Recovering your reply…",
  "assistant.progress.resending": "Checking your request…",
  "assistant.progress.working": "Still working on your reply…",
  "assistant.progress.earlier_request": "Finishing your earlier request first: {status}",
  "assistant.cancel": "Cancel",
  "assistant.retry": "Try again",
  "assistant.interrupted": "Reply interrupted. Recover it without another charge.",
  "assistant.not_started": "We couldn’t confirm your reply. Your message is saved; try Recover reply.",
  "assistant.connection_lost": "Connection lost. Recover without another charge.",
  "assistant.timed_out": "Request timed out. Recover without another charge.",
  "assistant.service_unavailable": "Service unavailable. Recover without another charge.",
  "assistant.invalid_reply": "Couldn’t read the reply. Recover without another charge.",
  "assistant.processing": "Still working. Check again shortly.",
  "assistant.failed": "Couldn’t finish. No credits charged. Try again.",
  "assistant.busy": "Usage limit reached. Your draft is saved. Try again later.",
  "assistant.project_access": "Open your own copy of this drawing to continue.",
  "assistant.expired": "Saved reply expired. Send a new request.",
  "assistant.error": "Something went wrong. Your drawing is unchanged.",
  "assistant.offline": "You’re offline. Your draft is saved.",
  "assistant.sign_in": "Sign in to continue",
  "assistant.sign_in_title": "Let’s build it together",
  "assistant.sign_in_description": "Create a free account or sign in to get help with your drawing.",
  "assistant.subscription": "View subscription",
  "assistant.top_up": "Add credits",
  "assistant.disabled": "Assistant access isn’t enabled for this account.",
  "assistant.credits": "Add credits to keep going.",
  "assistant.checkout_pending": "After checkout, return here and send your request.",
  "assistant.sources": "Sources",
  "assistant.proposal": "Proposed changes",
  "assistant.apply": "Apply changes",
  "assistant.applied": "Drawing updated",
  "assistant.dismiss": "Keep drawing",
  "assistant.dismissed": "Proposal dismissed",
  "assistant.stale": "The drawing changed. Send a new request.",
  "assistant.readonly": "Read-only drawing. You can still ask questions.",
  "assistant.preview": "Preview changes",
  "assistant.added": "{count} added",
  "assistant.removed": "{count} removed",
  "assistant.changed": "{count} updated",
  "assistant.new_conversation": "New chat",
  "assistant.new_keep_draft_confirm": "Clear previous messages and keep your draft?",
  "assistant.helpful": "Helpful",
  "assistant.not_helpful": "Not helpful",
  "assistant.feedback_saved": "Feedback saved",
  "assistant.feedback_failed": "Couldn’t save feedback. Try again.",
  "assistant.used": "{cost} credits used",
  "assistant.used_one": "{cost} credit used",
  "assistant.no_charge": "No credits used",
  "assistant.remaining": "{remaining} credits left",
  "assistant.remaining_one": "{remaining} credit left",
  "assistant.incoming": "Replace your unsent draft?",
  "assistant.keep_draft": "Keep draft",
  "assistant.replace_draft": "Use this issue",
  "assistant.detach": "Remove attached issue",
  "assistant.fix_prompt": "Help me resolve “{title}”. Explain the cause and make the smallest appropriate change.",
  "assistant.verify_specs_prompt": "Find the manufacturer’s datasheets for these components online. Check the AI-estimated specs, update only values supported by the exact model’s documentation, and link the sources. Keep anything you cannot verify marked as estimated.",
  "assistant.ask_prompt": "Help me understand “{title}” in this schematic.",
  "assistant.suggest_checks": "Check warnings",
  "assistant.suggest_checks_prompt": "Explain the most important warnings in my schematic and what I should check first.",
  "assistant.suggest_retrofit": "Plan a retrofit",
  "assistant.suggest_retrofit_prompt": "Help me plan a LiFePO₄ retrofit for the house battery in this schematic. Preserve the starter system and ask me about anything you cannot verify.",
  "assistant.suggest_load": "Add a load",
  "assistant.suggest_load_prompt": "I want to add another load to this schematic. What information do you need to connect it correctly?",
  "assistant.suggest_explain": "Explain",
  "assistant.suggest_explain_prompt": "Explain how the power sources, batteries, and loads in this schematic work together. Point out any missing information.",
  "assistant.quote_expired": "Request check expired. Send again.",
  "assistant.request_changed": "The request or drawing changed. Check and send again.",
  "assistant.continue": "Continue chat",
  "assistant.new_confirm": "Clear this view and start a new chat?",
} as const;
export const ASSISTANT_SV: Record<keyof typeof ASSISTANT_EN, string> = {
  ...ASSISTANT_EN,
  "assistant.follow_up": "Följ upp…",
  "assistant.queue_message": "Lägg i kö",
  "assistant.queued_messages": "Meddelanden i kö",
  "assistant.queued": "I kö",
  "assistant.queue_paused": "Pausad",
  "assistant.use_now": "Använd nu",
  "assistant.use_now_description": "Stoppa det pågående svaret och använd detta meddelande",
  "assistant.send_now": "Skicka nu",
  "assistant.edit_queued": "Redigera",
  "assistant.edit_queued_message": "Redigera meddelande i kö",
  "assistant.remove_queued": "Ta bort",
  "assistant.save_queued": "Spara",
  "assistant.stop": "Stoppa svaret",
  "assistant.stopping": "Stoppar…",
  "assistant.stopped": "Stoppat",
  "assistant.cancel_failed": "Kunde inte stoppa ännu. Försök igen.",
  "assistant.queue_full": "Kön är full. Ta bort ett meddelande för att lägga till ett nytt.",
  "assistant.not_applied": "Ändringarna gjordes inte.",
  "assistant.send_again": "Skicka en ny fråga för att försöka igen.",
  "assistant.undone": "Ändringen ångrad",
  "assistant.fullscreen": "Helskärm",
  "assistant.exit_fullscreen": "Lämna helskärm",
  "assistant.capped": "Assistenten är inte tillgänglig just nu. Ditt utkast är sparat.",
  "assistant.rate_limited": "För många förfrågningar. Utkastet är sparat. Försök igen om en stund.",
  "assistant.options": "Assistentmeny",
  "assistant.usage": "Krediter och användning",
  "assistant.usage_loading": "Hämtar saldo…",
  "assistant.usage_unavailable": "Saldot är inte tillgängligt. Försök igen.",
  "assistant.usage_explanation": "Krediter baseras på användning. Frågor kostar oftast mindre. Se kostnaden i varje svars meny.",
  "assistant.usage_limit": "Högst {cost} krediter per förfrågan. Tekniska fel är gratis.",
  "assistant.refresh_usage": "Uppdatera saldo",
  "assistant.message_options": "Meddelandealternativ",
  "assistant.low_credits": "{remaining} krediter kvar",
  "assistant.no_credits": "Inga krediter kvar.",
  "assistant.more_credits": "Det behövs fler krediter för den här förfrågan.",
  "assistant.send_notice": "Ditt meddelande och din ritning skickas. Ändringar kan ångras.",
  "assistant.about": "Om assistenten",
  "assistant.used_one": "{cost} kredit använd", "assistant.remaining_one": "{remaining} kredit kvar",

  "assistant.scope": "Energi utgår från simuleringen. Kabel- och säkringsdimensionering utgår från konstruktionen.",
  "assistant.interrupted": "Svaret avbröts. Hämta det utan en ny debitering.",
  "assistant.not_started": "Vi kunde inte bekräfta ditt svar. Ditt meddelande är sparat; prova Hämta svaret.",
  "assistant.connection_lost": "Anslutningen bröts. Hämta svaret utan en ny debitering.",
  "assistant.timed_out": "Förfrågan tog för lång tid. Hämta svaret utan en ny debitering.",
  "assistant.service_unavailable": "Tjänsten är inte tillgänglig. Hämta svaret utan en ny debitering.",
  "assistant.invalid_reply": "Kunde inte läsa svaret. Hämta det utan en ny debitering.",
  "assistant.processing": "Arbetar fortfarande. Försök hämta svaret snart igen.",
  "assistant.failed": "Kunde inte slutföra. Inga krediter drogs. Försök igen.",
  "assistant.busy": "Användningsgränsen är nådd. Utkastet är sparat. Försök senare.",
  "assistant.project_access": "Öppna en egen kopia av ritningen för att fortsätta.",
  "assistant.expired": "Det sparade svaret har gått ut. Skicka en ny fråga.",
  "assistant.drawn_wire": "Kabel i ritningen: {wire}", "assistant.drawn_fuse": "Säkring på kabeln: {fuse} A",
  "assistant.recover": "Hämta svaret",
  "assistant.open": "Assistent", "assistant.fix": "Åtgärda", "assistant.ask": "Fråga",
  "assistant.checks": "Systemkontroller", "assistant.checks_empty": "Inga problem att granska",
  "assistant.show_on_canvas": "Visa i ritningen", "assistant.close": "Stäng assistenten", "assistant.back": "Tillbaka till ritningen",
  "assistant.title": "Hur kan jag hjälpa?", "assistant.subtitle": "Ställ en fråga eller säg vad du vill lägga till, ta bort eller koppla om.",
  "assistant.context": "Din aktuella ritning",
  "assistant.placeholder": "Fråga Crimp…", "assistant.send": "Skicka",
  "assistant.choose_for_me": "Välj åt mig",
  "assistant.choose_for_me_prompt": "Välj åt mig.",

  "assistant.privacy": "Skickade meddelanden och resultat sparas i 90 dagar för att förbättra assistenten. Oskickade utkast stannar på den här enheten.",
  "assistant.progress.starting": "Startar…",
  "assistant.progress.reviewing_drawing": "Granskar din ritning…",
  "assistant.progress.preparing_answer": "Förbereder ett svar…",
  "assistant.progress.checking_answer": "Kontrollerar svaret…",
  "assistant.progress.checking_changes": "Kontrollerar ändringarna…",
  "assistant.progress.retrying": "Bearbetar svaret…",
  "assistant.progress.finishing": "Slutför…",
  "assistant.progress.recovering": "Hämtar ditt svar…",
  "assistant.progress.resending": "Kontrollerar din förfrågan…",
  "assistant.progress.working": "Arbetar fortfarande med ditt svar…",
  "assistant.progress.earlier_request": "Avslutar först din tidigare förfrågan: {status}",
  "assistant.cancel": "Avbryt", "assistant.retry": "Försök igen", "assistant.error": "Något gick fel. Ritningen är oförändrad.",
  "assistant.offline": "Du är offline. Utkastet är sparat.", "assistant.sign_in": "Logga in för att fortsätta",
  "assistant.sign_in_title": "Vi bygger det tillsammans",
  "assistant.sign_in_description": "Skapa ett gratis konto eller logga in för att få hjälp med din ritning.",
  "assistant.subscription": "Visa abonnemang", "assistant.top_up": "Fyll på krediter", "assistant.disabled": "Assistenten är inte aktiverad för det här kontot.",
  "assistant.credits": "Fyll på krediter för att fortsätta.", "assistant.checkout_pending": "Återvänd efter köpet och skicka din fråga.",
  "assistant.sources": "Källor", "assistant.proposal": "Föreslagna ändringar", "assistant.apply": "Tillämpa ändringar",
  "assistant.applied": "Ritningen uppdaterad", "assistant.dismiss": "Behåll ritningen", "assistant.dismissed": "Förslaget avvisat",
  "assistant.stale": "Ritningen har ändrats. Skicka en ny fråga.", "assistant.readonly": "Skrivskyddad ritning. Du kan fortfarande ställa frågor.",
  "assistant.preview": "Förhandsgranska ändringar", "assistant.added": "{count} tillagda", "assistant.removed": "{count} borttagna", "assistant.changed": "{count} uppdaterade",
  "assistant.new_conversation": "Ny chatt", "assistant.helpful": "Hjälpsamt", "assistant.not_helpful": "Inte hjälpsamt", "assistant.feedback_saved": "Feedback sparad",
  "assistant.new_keep_draft_confirm": "Rensa tidigare meddelanden och behålla utkastet?",
  "assistant.feedback_failed": "Kunde inte spara feedback. Försök igen.", "assistant.used": "{cost} krediter använda", "assistant.no_charge": "Inga krediter använda", "assistant.remaining": "{remaining} krediter kvar",
  "assistant.incoming": "Ersätta ditt oskickade utkast?", "assistant.keep_draft": "Behåll utkast", "assistant.replace_draft": "Använd problemet", "assistant.detach": "Ta bort bifogat problem",
  "assistant.fix_prompt": "Hjälp mig åtgärda ”{title}”. Förklara orsaken och gör minsta lämpliga ändring.", "assistant.ask_prompt": "Hjälp mig förstå ”{title}” i det här schemat.",
  "assistant.verify_specs_prompt": "Sök tillverkarens datablad för komponenterna på webben. Kontrollera de AI-uppskattade värdena, uppdatera bara det som stöds av dokumentationen för exakt modell och länka källorna. Behåll markeringar för värden som inte går att verifiera.",
  "assistant.suggest_checks": "Granska varningar", "assistant.suggest_checks_prompt": "Förklara de viktigaste varningarna i mitt schema och vad jag bör kontrollera först.",
  "assistant.suggest_retrofit": "Planera ombyggnad", "assistant.suggest_retrofit_prompt": "Hjälp mig planera ett byte till LiFePO₄ för förbrukningsbatteriet i det här schemat. Bevara startsystemet och fråga om det du inte kan verifiera.",
  "assistant.suggest_load": "Lägg till förbrukare", "assistant.suggest_load_prompt": "Jag vill lägga till en förbrukare i det här schemat. Vilka uppgifter behöver du för att ansluta den korrekt?",
  "assistant.suggest_explain": "Förklara", "assistant.suggest_explain_prompt": "Förklara hur strömkällorna, batterierna och förbrukarna i schemat samverkar. Peka ut information som saknas.",
  "assistant.quote_expired": "Kontrollen har gått ut. Skicka igen.", "assistant.request_changed": "Frågan eller ritningen ändrades. Kontrollera och skicka igen.",
  "assistant.continue": "Fortsätt chatten", "assistant.new_confirm": "Rensa den här vyn och starta en ny chatt?",
};
export const ASSISTANT_DE: Record<keyof typeof ASSISTANT_EN, string> = {
  ...ASSISTANT_EN,
  "assistant.follow_up": "Nachricht ergänzen…",
  "assistant.queue_message": "Nachricht einreihen",
  "assistant.queued_messages": "Nachrichten in der Warteschlange",
  "assistant.queued": "In der Warteschlange",
  "assistant.queue_paused": "Pausiert",
  "assistant.use_now": "Jetzt verwenden",
  "assistant.use_now_description": "Aktuelle Antwort stoppen und diese Nachricht verwenden",
  "assistant.send_now": "Jetzt senden",
  "assistant.edit_queued": "Bearbeiten",
  "assistant.edit_queued_message": "Nachricht in der Warteschlange bearbeiten",
  "assistant.remove_queued": "Entfernen",
  "assistant.save_queued": "Speichern",
  "assistant.stop": "Antwort stoppen",
  "assistant.stopping": "Wird gestoppt…",
  "assistant.stopped": "Gestoppt",
  "assistant.cancel_failed": "Noch nicht gestoppt. Versuche es erneut.",
  "assistant.queue_full": "Warteschlange voll. Entferne eine Nachricht, um eine neue hinzuzufügen.",
  "assistant.not_applied": "Änderungen wurden nicht vorgenommen.",
  "assistant.send_again": "Sende eine neue Anfrage, um es erneut zu versuchen.",
  "assistant.undone": "Änderung rückgängig gemacht",
  "assistant.fullscreen": "Vollbild",
  "assistant.exit_fullscreen": "Vollbild verlassen",
  "assistant.capped": "Der Assistent ist vorübergehend nicht verfügbar. Dein Entwurf ist gespeichert.",
  "assistant.rate_limited": "Zu viele Anfragen. Dein Entwurf ist gespeichert. Versuche es gleich erneut.",
  "assistant.options": "Assistentenmenü",
  "assistant.usage": "Credits und Nutzung",
  "assistant.usage_loading": "Guthaben wird geladen…",
  "assistant.usage_unavailable": "Guthaben nicht verfügbar. Versuche es erneut.",
  "assistant.usage_explanation": "Credits richten sich nach der Nutzung. Fragen kosten meist weniger. Die Kosten stehen im Menü jeder Antwort.",
  "assistant.usage_limit": "Bis zu {cost} Credits pro Anfrage. Technische Fehler sind kostenlos.",
  "assistant.refresh_usage": "Guthaben aktualisieren",
  "assistant.message_options": "Nachrichtenoptionen",
  "assistant.low_credits": "{remaining} Credits übrig",
  "assistant.no_credits": "Keine Credits übrig.",
  "assistant.more_credits": "Für diese Anfrage brauchst du mehr Credits.",
  "assistant.send_notice": "Sendet deine Nachricht und deinen Schaltplan. Änderungen lassen sich rückgängig machen.",
  "assistant.about": "Über den Assistenten",
  "assistant.used_one": "{cost} Credit verwendet", "assistant.remaining_one": "{remaining} Credit übrig",

  "assistant.scope": "Energie basiert auf der Simulation. Kabel und Sicherungen werden nach dem Plan dimensioniert.",
  "assistant.interrupted": "Antwort unterbrochen. Ohne erneute Abbuchung abrufen.",
  "assistant.not_started": "Deine Antwort konnte nicht bestätigt werden. Deine Nachricht ist gespeichert; wähle „Antwort abrufen“.",
  "assistant.connection_lost": "Verbindung unterbrochen. Ohne erneute Abbuchung abrufen.",
  "assistant.timed_out": "Zeitlimit überschritten. Ohne erneute Abbuchung abrufen.",
  "assistant.service_unavailable": "Dienst nicht verfügbar. Ohne erneute Abbuchung abrufen.",
  "assistant.invalid_reply": "Antwort konnte nicht gelesen werden. Ohne erneute Abbuchung abrufen.",
  "assistant.processing": "Noch in Bearbeitung. Rufe die Antwort gleich erneut ab.",
  "assistant.failed": "Nicht abgeschlossen. Keine Credits berechnet. Versuche es erneut.",
  "assistant.busy": "Nutzungslimit erreicht. Dein Entwurf ist gespeichert. Versuche es später.",
  "assistant.project_access": "Öffne eine eigene Kopie des Schaltplans, um fortzufahren.",
  "assistant.expired": "Gespeicherte Antwort abgelaufen. Sende eine neue Anfrage.",
  "assistant.drawn_wire": "Kabel im Plan: {wire}", "assistant.drawn_fuse": "Kabelsicherung: {fuse} A",
  "assistant.recover": "Antwort abrufen",
  "assistant.open": "Assistent", "assistant.fix": "Beheben", "assistant.ask": "Fragen", "assistant.checks": "Systemprüfung", "assistant.checks_empty": "Keine Probleme zu prüfen",
  "assistant.show_on_canvas": "Im Schaltplan zeigen", "assistant.close": "Assistent schließen", "assistant.back": "Zurück zum Schaltplan",
  "assistant.title": "Wie kann ich helfen?", "assistant.subtitle": "Stelle eine Frage oder sage, was ich hinzufügen, entfernen oder neu verbinden soll.", "assistant.context": "Dein aktueller Schaltplan",
  "assistant.placeholder": "Frag Crimp…",
  "assistant.send": "Senden",
  "assistant.choose_for_me": "Wähle für mich",
  "assistant.choose_for_me_prompt": "Wähle für mich.",

  "assistant.privacy": "Gesendete Nachrichten und Ergebnisse werden zur Verbesserung des Assistenten 90 Tage gespeichert. Ungesendete Entwürfe bleiben auf diesem Gerät.",
  "assistant.progress.starting": "Wird gestartet…",
  "assistant.progress.reviewing_drawing": "Dein Schaltplan wird geprüft…",
  "assistant.progress.preparing_answer": "Antwort wird vorbereitet…",
  "assistant.progress.checking_answer": "Antwort wird geprüft…",
  "assistant.progress.checking_changes": "Änderungen werden geprüft…",
  "assistant.progress.retrying": "Antwort wird überarbeitet…",
  "assistant.progress.finishing": "Wird abgeschlossen…",
  "assistant.progress.recovering": "Deine Antwort wird abgerufen…",
  "assistant.progress.resending": "Deine Anfrage wird geprüft…",
  "assistant.progress.working": "Deine Antwort wird noch erarbeitet…",
  "assistant.progress.earlier_request": "Zuerst wird deine frühere Anfrage abgeschlossen: {status}",
  "assistant.cancel": "Abbrechen", "assistant.retry": "Erneut versuchen",
  "assistant.error": "Etwas ist schiefgelaufen. Dein Schaltplan ist unverändert.", "assistant.offline": "Du bist offline. Dein Entwurf ist gespeichert.",
  "assistant.sign_in": "Zum Fortfahren anmelden", "assistant.subscription": "Abonnement ansehen", "assistant.top_up": "Credits aufladen", "assistant.disabled": "Der Assistent ist für dieses Konto nicht freigeschaltet.",
  "assistant.sign_in_title": "Lass uns gemeinsam planen",
  "assistant.sign_in_description": "Erstelle ein kostenloses Konto oder melde dich an, um Hilfe mit deinem Schaltplan zu bekommen.",
  "assistant.credits": "Lade Credits auf, um weiterzumachen.", "assistant.checkout_pending": "Kehre nach dem Kauf zurück und sende deine Anfrage.",
  "assistant.sources": "Quellen", "assistant.proposal": "Vorgeschlagene Änderungen", "assistant.apply": "Änderungen anwenden", "assistant.applied": "Schaltplan aktualisiert",
  "assistant.dismiss": "Schaltplan beibehalten", "assistant.dismissed": "Vorschlag verworfen", "assistant.stale": "Der Schaltplan wurde geändert. Sende eine neue Anfrage.",
  "assistant.readonly": "Schreibgeschützter Plan. Du kannst weiterhin Fragen stellen.", "assistant.preview": "Änderungen ansehen",
  "assistant.added": "{count} hinzugefügt", "assistant.removed": "{count} entfernt", "assistant.changed": "{count} aktualisiert", "assistant.new_conversation": "Neuer Chat",
  "assistant.new_keep_draft_confirm": "Frühere Nachrichten löschen und deinen Entwurf behalten?",
  "assistant.helpful": "Hilfreich", "assistant.not_helpful": "Nicht hilfreich", "assistant.feedback_saved": "Feedback gespeichert", "assistant.feedback_failed": "Feedback nicht gespeichert. Versuche es erneut.",
  "assistant.used": "{cost} Credits verwendet", "assistant.no_charge": "Keine Credits verwendet", "assistant.remaining": "{remaining} Credits übrig",
  "assistant.incoming": "Ungesendeten Entwurf ersetzen?", "assistant.keep_draft": "Entwurf behalten", "assistant.replace_draft": "Dieses Problem verwenden", "assistant.detach": "Angehängtes Problem entfernen",
  "assistant.fix_prompt": "Hilf mir, „{title}“ zu beheben. Erkläre die Ursache und nimm die kleinste passende Änderung vor.", "assistant.ask_prompt": "Hilf mir, „{title}“ in diesem Schaltplan zu verstehen.",
  "assistant.verify_specs_prompt": "Suche online nach den Herstellerdatenblättern dieser Komponenten. Prüfe die KI-geschätzten Werte, aktualisiere nur belegte Angaben für das genaue Modell und verlinke die Quellen. Nicht überprüfbare Werte bleiben als geschätzt markiert.",
  "assistant.suggest_checks": "Warnungen prüfen", "assistant.suggest_checks_prompt": "Erkläre die wichtigsten Warnungen in meinem Schaltplan und was ich zuerst prüfen sollte.",
  "assistant.suggest_retrofit": "Umrüstung planen", "assistant.suggest_retrofit_prompt": "Hilf mir, eine LiFePO₄-Umrüstung der Verbraucherbatterie in diesem Schaltplan zu planen. Erhalte das Startsystem und frage nach, wenn Angaben fehlen.",
  "assistant.suggest_load": "Verbraucher hinzufügen", "assistant.suggest_load_prompt": "Ich möchte einen weiteren Verbraucher hinzufügen. Welche Angaben brauchst du für den korrekten Anschluss?",
  "assistant.suggest_explain": "Erklären", "assistant.suggest_explain_prompt": "Erkläre, wie Stromquellen, Batterien und Verbraucher in diesem Schaltplan zusammenarbeiten. Zeige fehlende Angaben auf.",
  "assistant.quote_expired": "Prüfung abgelaufen. Sende erneut.", "assistant.request_changed": "Anfrage oder Schaltplan geändert. Prüfe und sende erneut.",
  "assistant.continue": "Chat fortsetzen", "assistant.new_confirm": "Diese Ansicht leeren und einen neuen Chat starten?",
};
